var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 72,
    viewBox: "0 0 78 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875977 28.5696C0.875977 28.0592 1.28969 27.6455 1.80003 27.6455H66.4836C66.9939 27.6455 67.4076 28.0592 67.4076 28.5696V64.6075C67.4076 68.6903 64.0979 71.9999 60.0152 71.9999H8.26838C4.18566 71.9999 0.875977 68.6902 0.875977 64.6075V28.5696Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.875977 18.0355C0.875977 13.9528 4.18567 10.6431 8.26838 10.6431H60.0152C64.0979 10.6431 67.4076 13.9528 67.4076 18.0355V20.8076C67.4076 21.318 66.9939 21.7317 66.4836 21.7317H1.80002C1.28968 21.7317 0.875977 21.318 0.875977 20.8076V18.0355Z",
    fill: "#D1D5DB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.124,
    y: 36,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.124,
    y: 46,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.124,
    y: 56,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.124,
    y: 36,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.124,
    y: 46,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 23.124,
    y: 56,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 36.124,
    y: 36,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5015,
    y: 36.5164,
    width: 9.61013,
    height: 6.65316,
    rx: 1.8481,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 49.124,
    y: 36,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36.124,
    y: 46,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.124,
    y: 46,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36.124,
    y: 56,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 49.124,
    y: 56,
    width: 10,
    height: 7,
    rx: 1.8481,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10.124,
    y: 5,
    width: 10,
    height: 11,
    rx: 1.8481,
    fill: "#D1D5DB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.124,
    cy: 17,
    r: 17,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_2395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 30C67.1797 30 73 24.1797 73 17C73 9.8203 67.1797 4 60 4C52.8203 4 47 9.8203 47 17C47 24.1797 52.8203 30 60 30Z",
    fill: "#44837D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0963 18.0369C54.8153 17.7537 54.3581 17.7519 54.0749 18.0328C53.7917 18.3137 53.7899 18.771 54.0708 19.0542L55.0963 18.0369ZM58.0657 22.0555L57.553 22.5642C57.7006 22.7129 57.9055 22.7903 58.1145 22.7761C58.3236 22.7619 58.5162 22.6576 58.6424 22.4903L58.0657 22.0555ZM65.9936 12.7403C66.2337 12.4218 66.1702 11.969 65.8517 11.7288C65.5332 11.4887 65.0803 11.5522 64.8402 11.8707L65.9936 12.7403ZM54.0708 19.0542L57.553 22.5642L58.5784 21.5469L55.0963 18.0369L54.0708 19.0542ZM58.6424 22.4903L65.9936 12.7403L64.8402 11.8707L57.489 21.6207L58.6424 22.4903Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_2395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(47 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/calendar-check.6f073036.svg";
export { ForwardRef as ReactComponent };